import { Box } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { announcementService } from '../../../shared/services/announcement/announcementService';
import { Card } from '../../../shared/components/ui/Card';
import { AnnouncementForm } from '../components/AnnouncementForm/AnnouncementForm';

export default function AnnouncementFormPage() {
  const { id } = useParams<{ id: string }>();
  const isEdit = !!id;

  const { data: announcement, isLoading } = useQuery({
    queryKey: ['announcement', id],
    queryFn: () => announcementService.get(id!).then(res => res.data),
    enabled: isEdit
  });

  if (isEdit && isLoading) return null;

  return (
    <Box sx={{ p: { xs: 1, md: 4 }, background: '#F6F8FB', minHeight: '100vh' }}>
      <Card sx={{ background: '#fff', borderRadius: 4, p: 4, maxWidth: 900, margin: '32px auto', boxShadow: '0 2px 8px 0 rgba(16,30,54,0.04)' }}>
        <AnnouncementForm 
          announcement={announcement} 
          isEdit={isEdit}
        />
      </Card>
    </Box>
  );
}